import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNrday70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_70: Record<
  Exclude<PageIdWoofzNrday70, PageIdWoofzNrday70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NRDAY_70_N]: {
    id: PageId.SUBSCRIPTIONS_NRDAY_70_N,
  },
  [PageId.CHAT_UPSELL_NRDAY_70]: {
    id: PageId.CHAT_UPSELL_NRDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NRDAY_70]: {
    id: PageId.UPSELL_NRDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NRDAY_70]: {
    id: PageId.DOWNLOAD_NRDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
